export default "__VITE_PUBLIC_ASSET__94f59dbf__"